<div class="tour-online-booking-img">
    <img src="/img/hottable/desktop/tour-online-booking.png"> 
</div>